module.exports = __webpack_public_path__ + "img/icon80.f613979c.png";